import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export class GetMakeModelFaqsUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Fetcher} deps.repository
   * @param {Object} deps.log
   */
  constructor({config, httpSeoRepository, makeModelFaqsRequestFactory}) {
    super()
    this._config = config
    this._makeModelFaqsRequestFactory = makeModelFaqsRequestFactory
    this._httpSeoRepository = httpSeoRepository
  }

  @tracer({metric: 'GetMakeModelFaqsUseCase#execute'})
  @inlineError
  execute({make, model}) {
    const makeModelFaqsRequest = this._makeModelFaqsRequestFactory({
      make,
      model
    })

    return this._httpSeoRepository.getMakeModelFaqs(makeModelFaqsRequest).then(([error, faqs]) => {
      if (error) {
        return Promise.reject(error)
      }
      return faqs.toJSON()
    })
  }
}
